import type React from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { useAuth } from './hooks/useAuth.ts';
import { LoginPage } from './pages/LoginPage.tsx';
import { DashboardPage } from './pages/DashboardPage.tsx';
import { IndustryDetailPage } from './pages/IndustryDetailPage.tsx';
import { SettingsPage } from './pages/SettingsPage.tsx';

export const App = (): React.JSX.Element => {
  const auth = useAuth();
  const location = useLocation();

  if (auth.status === 'loading') {
    return <main style={loadingStyle}>セッション確認中…</main>;
  }

  // POTAL から来たときの portal_code（引換番号）・portal_login=1 などの portal_* は、
  // 読み込んだ時点で lib/portal-arrival.ts が受け取ってアドレス欄から消し、useAuth が先にログインへ替えている。
  // 未ログインのときは `/login` に転送する（ほかのクエリは持っていく）。
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      {auth.status === 'authenticated' ? (
        <>
          <Route
            path="/"
            element={<DashboardPage user={auth.user} onLogout={auth.logout} />}
          />
          <Route
            path="/industry/:id"
            element={<IndustryDetailPage user={auth.user} onLogout={auth.logout} />}
          />
          <Route
            path="/settings"
            element={<SettingsPage user={auth.user} onLogout={auth.logout} />}
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </>
      ) : (
        <Route
          path="*"
          element={<Navigate to={`/login${location.search}`} replace />}
        />
      )}
    </Routes>
  );
};

const loadingStyle: React.CSSProperties = {
  textAlign: 'center',
  padding: 80,
  color: '#777',
};
